import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import { useRouter } from "next/router";
import { withActiveToken } from "../lib/auth";
import { getAPIURL } from "../lib/utils";
import BusinessContext from "./business-context";

const TableFilterContext = createContext({
activeFilters: null,
setActiveFilters: () => {},
filterValues: null,
setFilterValues: () => {},
newFilterId: null,
setNewFilterId: () => {},
    
});

export const TableFilterProvider = (props) => {
    const router = useRouter();
    const [activeFilters, setActiveFilters] = useState(null);
    const [filterValues, setFilterValues] = useState(null);
    const [newFilterId, setNewFilterId] = useState(null);

  // Reset filters when navigating to a different page (pathname changes)
  useEffect(() => {
    const handleRouteChange = (url) => {
      const currentPath = router.asPath.split('?')[0];
      const newPath = url.split('?')[0];
      
      // Only reset if the pathname actually changed (not just query params)
      if (currentPath !== newPath) {
        setActiveFilters(null);
        setFilterValues(null);
        setNewFilterId(null);
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  const context = {
    activeFilters,
    setActiveFilters,
    filterValues,
    setFilterValues,
    newFilterId,
    setNewFilterId,
  };

  return (
    <TableFilterContext.Provider value={context}>
      {props.children}
    </TableFilterContext.Provider>
  );
};

export default TableFilterContext;
